// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "frontoffice.umd.min." + ({"1570":"merchants-orders","2443":"about","3085":"wires","6666":"merchants","7296":"privacy","8234":"merchants-finance"}[chunkId] || chunkId) + ".js";
};